module.exports = __webpack_public_path__ + "static/media/logo4.bec92191.png";